'use client';

import React, { useState } from 'react';
import { buildDsmImageProps } from '@/aem-dsm-mappers/utils/imageProps';
import './FeaturedProduct.css';

const FeaturedProduct = ({ data }) => {
  const { title, eyebrow, description, swatchImagesTitle, swatchImages = [], cardImage } = data;

  const [activeIndex, setActiveIndex] = useState(0);

  const activeItem = swatchImages[activeIndex];
  const activeImage = activeItem?.pairImage || cardImage;

  return (
    <section className="fp">
      <div className="fp__inner">
        <div className="fp__content">
          {eyebrow && <p className="fp__eyebrow">{eyebrow}</p>}

          {title && <h3 className="fp__title">{title}</h3>}

          {description && (
            <div className="fp__desc" dangerouslySetInnerHTML={{ __html: description }} />
          )}

          <div className="optionsBlock">
            <div className="colorFinishBlock">
              {swatchImages.length > 0 && swatchImagesTitle && (
                <p className="colorFinishLabel">
                  {swatchImagesTitle}{' '}
                  <span className="additionalText">{activeItem?.swatchTitle}</span>
                </p>
              )}
              <div className="swatchGroup">
                {swatchImages.map((item, index) => (
                  <button
                    key={index}
                    className={`swatchItem ${activeIndex === index ? 'swatchActive' : ''}`}
                    onClick={() => setActiveIndex(index)}
                  >
                    <div className="swatchColor">
                      <img src={item.swatchImage} alt={item.swatchTitle} />
                    </div>

                    <span className="swatchLabel">{item.swatchTitle}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* IMAGE (RIGHT) */}
        <div className="fp__image">
          <img
            {...buildDsmImageProps({
              src: activeImage,
              alt: 'Product',
              allowEmptySrc: true,
            })}
          />
        </div>
      </div>
    </section>
  );
};

export default React.memo(FeaturedProduct);
